var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15945 10.869C9.05945 10.859 8.93945 10.859 8.82945 10.869C6.44945 10.789 4.55945 8.83902 4.55945 6.43902C4.55945 3.98902 6.53945 1.99902 8.99945 1.99902C11.4494 1.99902 13.4394 3.98902 13.4394 6.43902C13.4294 8.83902 11.5394 10.789 9.15945 10.869Z",
    stroke: "#091F28",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4097 4.00098C18.3497 4.00098 19.9097 5.57098 19.9097 7.50098C19.9097 9.39098 18.4097 10.931 16.5397 11.001C16.4597 10.991 16.3697 10.991 16.2797 11.001",
    stroke: "#091F28",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1596 14.561C1.7396 16.181 1.7396 18.821 4.1596 20.431C6.9096 22.271 11.4196 22.271 14.1696 20.431C16.5896 18.811 16.5896 16.171 14.1696 14.561C11.4296 12.731 6.9196 12.731 4.1596 14.561Z",
    stroke: "#091F28",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 19.999C19.0598 19.849 19.7398 19.559 20.2998 19.129C21.8598 17.959 21.8598 16.029 20.2998 14.859C19.7498 14.439 19.0798 14.159 18.3698 13.999",
    stroke: "#091F28",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.6eb2c5f76cecc2abb76beb49c03e27af.svg";
export { ForwardRef as ReactComponent };